import { render, staticRenderFns } from "./energyPage.vue?vue&type=template&id=483fc3d8"
import script from "./energyPage.vue?vue&type=script&lang=js"
export * from "./energyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports